import { IonFabButtonMenuItem, IonFabButtonStore } from "@/types/global";
import { defineStore } from "pinia";

function getInitialIonFabButtonStore(): IonFabButtonStore {
  return { MenuItems: null, OwnerKey: null };
}

let nextOwnerKey = 0;

// Each view claims the FAB under its own key. Ionic runs the entering view's
// willEnter BEFORE the leaving view's willLeave, so an unowned clear from the
// leaving view would wipe the menu the entering view just applied (B17).
export function createFabOwnerKey(): number {
  nextOwnerKey += 1;
  return nextOwnerKey;
}

export const useIonFabButtonStore = defineStore("ionFabButtonStore", {
  state: (): IonFabButtonStore => getInitialIonFabButtonStore(),
  getters: {},
  actions: {
    applyMenu(ownerKey: number, menuItems: Array<IonFabButtonMenuItem>) {
      this.OwnerKey = ownerKey;
      this.MenuItems = menuItems;
    },
    clearMenu(ownerKey: number) {
      if (this.OwnerKey !== ownerKey) {
        return;
      }
      this.MenuItems = null;
      this.OwnerKey = null;
    },
  },
});
